export default __webpack_public_path__ + "exclamation-mark-small.b3bbf72eba9c892e.svg";